<template>
  <!-- Main banner -->
  <section class="pt-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div
            class="card overflow-hidden h-100px h-xl-200px rounded-3"
            style="
              background-image: url(/assets/images/bg/fondo-acercade-viaverde.jpg);
              background-position: center left;
              background-size: cover;
            "
          >
            <div class="bg-overlay bg-dark opacity-6"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Contenido principal -->
  <div class="container mt-4">
    <div v-if="loading" class="text-center py-5">
      <p>Cargando noticia...</p>
    </div>

    <div v-else-if="error" class="alert alert-danger mt-3">
      {{ error }}
    </div>

    <div v-else-if="news" class="row g-4">
      <div class="col-xl-8">
        <div class="row g-4 mb-4">
          <!-- 🔙 Botón Volver -->
          <div class="col-12">
            <button @click="goToNews" class="btn btn-green btn-sm rounded-pill">
              <i class="fas fa-arrow-left me-2"></i> Volver atrás
            </button>
          </div>

          <!-- Título y fecha -->
          <div class="col-12">
            <h2>{{ news.title }}</h2>
            <p class=" mb-2 fecha">
              <i class="far fa-clock text-danger me-2"></i>
              {{ formatDate(news.date) }}
            </p>
            <p class="news-summary">{{ news.summary }}</p>
          </div>

          <!-- Imagen -->
          <div class="col-12 position-relative" v-if="news.image_path">
            <div class="video-player rounded-3 overflow-hidden">
              <img
                :src="news.image_path"
                :alt="news.title"
                :title="news.title"
                class="img-fluid w-100"
              />
            </div>
          </div>

          <!-- Detalle -->
          <div class="col-12">
            <div class="card border">
              <div class="card-body detalle-noticia">
                <div v-html="news.detail"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Columna lateral -->
      <div class="col-xl-4">
        <div data-sticky data-margin-top="80" data-sticky-for="768">
          <div class="card card-body border p-4">
            <h5 class="mb-3">Vea También</h5>
            <ul class="nav flex-column">
              <!-- Noticias -->
              <li class="nav-item">
                <button
                  class="btn btn-link nav-link d-flex text-start p-0"
                  @click="goToNews"
                >
                  <i class="fas fa-angle-right text-primary pt-1 me-2"></i>
                  Noticias
                </button>
              </li>

              <!-- Publicaciones -->
              <!-- <li class="nav-item">
                <button
                  class="btn btn-link nav-link d-flex text-start p-0"
                  @click="goToPublications"
                >
                  <i class="fas fa-angle-right text-primary pt-1 me-2"></i>
                  Publicaciones
                </button>
              </li> -->

              <!-- Directorio -->
              <li class="nav-item">
                <button
                  class="btn btn-link nav-link d-flex text-start p-0"
                  @click="goToDirectory"
                >
                  <i class="fas fa-angle-right text-primary pt-1 me-2"></i>
                  Directorio
                </button>
              </li>
            </ul>
            <hr />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useNewsDetailStore } from "@/modules/news/stores/newsDetail";
import { useRouter } from "vue-router";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const newsStore = useNewsDetailStore();
    const { news, loading, error } = storeToRefs(newsStore);

    const goToNews = () => {
      router.push({ name: "news-home" });
    };

    const goToDirectory = () => router.push({ name: "directory-home" });

    const formatDate = (date) => {
      if (!date) return "";
      const d = new Date(date + "T00:00:00");
      return d.toLocaleDateString("es-BO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    };

    onMounted(() => {
      newsStore.fetchNewsDetail(route.params.id);
    });

    return { news, loading, error, formatDate, goToNews, goToDirectory };
  },
};
</script>

<style scoped>
  .fecha{
    font-family: "Montserrat";
    color: black;
  }
  h2{
    font-family: "Merriweather";  
  }
  .detalle-noticia{
    font-family: "Montserrat";
    text-align: justify;
  }
.video-player img {
  object-fit: cover;
  max-height: 400px;
}

@media (max-width: 768px) {
  .video-player img {
    max-height: 250px;
  }
}

.news-summary {
  font-family: "Montserrat";
  font-size: 1.2rem; /* tamaño base (fs-5 ≈ 1.25rem) */
  line-height: 1.6;
  text-align: justify;
}

@media (max-width: 992px) {
  .news-summary {
    font-size: 1rem;
  }
}

@media (max-width: 576px) {
  .news-summary {
    font-size: 0.95rem;
  }
}
</style>
